/** @jsx jsx */
import React from "react";
import { graphql } from "gatsby";
import { jsx, Container } from "theme-ui";
import Form from "../../shared/form";

export const query = graphql`
  fragment ContentfulFormSectionFragment on ContentfulFormSection {
    form {
      ...FormFragment
    }
  }
`;

const FormSection = ({ sectionContent }) => (
    <Container>
      <Form {...sectionContent.form} />
    </Container>
);

export default FormSection;
